import { render, staticRenderFns } from "./EventsEdit.vue?vue&type=template&id=e964dd50&scoped=true&"
import script from "./EventsEdit.vue?vue&type=script&lang=js&"
export * from "./EventsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e964dd50",
  null
  
)

export default component.exports